import type { RouteRecordRaw } from 'vue-router'
import KyaPage from './KyaPage.vue'

export const kyaRoutes: RouteRecordRaw[] = [
  {
    path: '/compliance/kya',
    name: 'compliance.kya',
    component: KyaPage,
    meta: { layout: 'admin', requiresAuth: true },
  },
]
